<template>
  <v-dialog :value="dialog" persistent max-width="700">
    <v-card>
      <v-card-title class="text-h5"> Create Tool Set </v-card-title>

      <div class="px-5 my-5">
        <v-text-field
          label="Tool Set Name"
          placeholder="Tool Set Name"
          outlined
          v-model="ToolName"
        ></v-text-field>
      </div>

      <v-row class="ma-0" align="center" justify="center" v-for="item in this.selectedToolIds" :key="item.id">
        <v-col class="tool_col">
          <p class="font-weight-bold ma-0">
            {{item?.name}}
          </p>
        </v-col>
        <v-col class="tool_del" >
          <v-btn width="25" icon color="error" @click.stop="deleteTool(item?.id)">
            <v-icon> mdi-delete </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-autocomplete
          ref="toolSelect"
          class="mb-3 ml-5 mr-5 mt-5"
          outlined
          dense
          @input="(val) => setNewTool(val)"
          item-text="name"
          item-value="id"
          :items="Tools"
          label="Add Action"
          :append-outer-icon="fetchToolsLoading ? 'mdi-loading mdi-spin' : 'mdi-reload'"
          @click:append-outer="listTools"
          clearable></v-autocomplete>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close')"> Cancel </v-btn>
        <v-btn color="blue darken-1" text @click="createNewSet()" :loading="createToolSetLoading"> Create </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const {
  mapActions: AIChatActions,
  mapGetters: AIChatGetters,
} = createNamespacedHelpers('AIChat');
const {  mapGetters: toolsGetters, mapActions: toolsActions } =
    createNamespacedHelpers('promptsTools');

export default {
  name: 'CreateActionSet',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ToolName: '',
      selectedToolIds: [],
      selectedTools: [],
    };
  },
  computed: {
    ...toolsGetters({
      Tools: 'TOOLS',
      fetchToolsLoading: 'fetchToolsLoading'
    }),
    ...AIChatGetters({
      createToolSetLoading: 'CREATE_TOOL_SET_LOADING'
    })
  },
  methods: {
    ...AIChatActions(['createToolSet']),
    ...toolsActions(['fetchTools']),
    async listTools() {
      await this.fetchTools()
    },
    setNewTool(val) {
      const exists = this.selectedTools.find((tool) => tool.id === val)
      if(exists || !val) {
        return;
      }
      const tool = this.Tools.find((tool) => tool?.id === val);
      this.selectedToolIds = [...this.selectedToolIds, tool];
    },
    deleteTool(val) {
      const tools = this.selectedTools.filter((tool) => tool?.id !== val);
      this.selectedToolIds = [...tools];
    },
    async createNewSet() {
      await this.createToolSet({
        toolSetIds: this.selectedToolIds.map((tool) => tool.id),
        name: this.ToolName,
      })
      this.$emit('close');
    }
  },
  async created() {
    await this.fetchTools()
  }
};
</script>

<style lang="scss" scoped>
@import 'create-tool-set';
</style>
